export const organizationTypeOptions = [
  { label: 'Select', value: '' },
  { label: 'Company', value: 'company' },
  { label: 'Consultancy', value: 'consultancy' }
];

export const employeeOptions = [
  { label: 'Select', value: '' },
  { label: '1-10', value: '1-10' },
  { label: '11-50', value: '11-50' },
  { label: '51-200', value: '51-200' },
  { label: '200+', value: '200+' }
];
